// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CartItems_cart-items__header__nuKKp {
  display: flex;
  gap: 1.5rem;
  align-items: center;
  margin-bottom: 3.2rem;
}

.CartItems_cart-items__title__805bd {
  color: #000;
  font-size: var(--text-xl);
  font-weight: 700;
}

.CartItems_cart-items__quantity__OkmMw {
  color: var(--gray-dark);
  font-size: var(--text-base);
  font-weight: 500;
}

.CartItems_cart-items-table__item-name-title__7p--r {
  color: var(--gray-dark);
  font-size: var(--text-base);
  font-weight: 500;
  line-height: 1.8rem;
}

.CartItems_cart-items-table__sku-name__UMJcu {
  margin-top: 0.9rem;
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
}

.CartItems_cart-items-table__bundle-skus-list__c5zQf {
  margin-top: 2.9rem;
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.CartItems_cart-items-table__bundle-sku-list-item__QHXtl {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
  display: flex;
  align-items: flex-start;
}

.CartItems_cart-items-table__bundle-sku-list-item__QHXtl::before {
  content: "";
  margin: 1rem 2rem 0 1rem;
  width: 0.6rem;
  height: 0.6rem;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: #000;
}

.CartItems_cart-items-table__price-error__hhkkn {
  margin-bottom: 2rem;
}

.CartItems_cart-items-table__new-price-label__ULBrj {
  margin-block: 2rem 0.2rem;
  color: var(--primary-color);
  font-size: var(--text-lg);
  font-weight: 500;
}

.CartItems_cart-items-table__new-price-wrapper__2idN0 {
  display: flex;
  align-items: flex-end;
  gap: 0.6rem;
  font-size: var(--text-lg);
  font-weight: 500;
}

.CartItems_cart-items-table__new-price-currency__Du839 {
  font-size: var(--text-base);
}

.CartItems_cart-items-table__new-price-actions__w59ku {
  margin-top: 2rem;
  display: flex;
  align-items: center;
  gap: 3rem;
}

.CartItems_cart-items-table__new-price-reject-btn__Y81qw,
.CartItems_cart-items-table__new-price-accept-btn__ftMD2 {
  padding: 1.4rem 2.4rem;
}
.CartItems_cart-items-table__quantity-controls__5dclv {
  max-width: 13rem;
  gap: 1rem;
  margin-inline: auto;
}

.CartItems_cart-items-table__quantity-error__qzfkg {
  margin-top: 2rem;
}

.CartItems_cart-items-table__delete-btn__2XllU {
  margin-inline: auto;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .CartItems_cart-items-table__sku-name__UMJcu {
    font-size: var(--text-base);
  }

  .CartItems_cart-items-table__bundle-sku-list-item__QHXtl {
    font-size: var(--text-base);
  }

  .CartItems_cart-items-table__quantity-controls__5dclv {
    max-width: 12rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Cart/CartItems/CartItems.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".cart-items__header {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n  margin-bottom: 3.2rem;\n}\n\n.cart-items__title {\n  color: #000;\n  font-size: var(--text-xl);\n  font-weight: 700;\n}\n\n.cart-items__quantity {\n  color: var(--gray-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.cart-items-table__item-name-title {\n  color: var(--gray-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n  line-height: 1.8rem;\n}\n\n.cart-items-table__sku-name {\n  margin-top: 0.9rem;\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.cart-items-table__bundle-skus-list {\n  margin-top: 2.9rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.4rem;\n}\n\n.cart-items-table__bundle-sku-list-item {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n  display: flex;\n  align-items: flex-start;\n}\n\n.cart-items-table__bundle-sku-list-item::before {\n  content: \"\";\n  margin: 1rem 2rem 0 1rem;\n  width: 0.6rem;\n  height: 0.6rem;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background-color: #000;\n}\n\n.cart-items-table__price-error {\n  margin-bottom: 2rem;\n}\n\n.cart-items-table__new-price-label {\n  margin-block: 2rem 0.2rem;\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.cart-items-table__new-price-wrapper {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.6rem;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.cart-items-table__new-price-currency {\n  font-size: var(--text-base);\n}\n\n.cart-items-table__new-price-actions {\n  margin-top: 2rem;\n  display: flex;\n  align-items: center;\n  gap: 3rem;\n}\n\n.cart-items-table__new-price-reject-btn,\n.cart-items-table__new-price-accept-btn {\n  padding: 1.4rem 2.4rem;\n}\n.cart-items-table__quantity-controls {\n  max-width: 13rem;\n  gap: 1rem;\n  margin-inline: auto;\n}\n\n.cart-items-table__quantity-error {\n  margin-top: 2rem;\n}\n\n.cart-items-table__delete-btn {\n  margin-inline: auto;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .cart-items-table__sku-name {\n    font-size: var(--text-base);\n  }\n\n  .cart-items-table__bundle-sku-list-item {\n    font-size: var(--text-base);\n  }\n\n  .cart-items-table__quantity-controls {\n    max-width: 12rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cart-items__header": `CartItems_cart-items__header__nuKKp`,
	"cart-items__title": `CartItems_cart-items__title__805bd`,
	"cart-items__quantity": `CartItems_cart-items__quantity__OkmMw`,
	"cart-items-table__item-name-title": `CartItems_cart-items-table__item-name-title__7p--r`,
	"cart-items-table__sku-name": `CartItems_cart-items-table__sku-name__UMJcu`,
	"cart-items-table__bundle-skus-list": `CartItems_cart-items-table__bundle-skus-list__c5zQf`,
	"cart-items-table__bundle-sku-list-item": `CartItems_cart-items-table__bundle-sku-list-item__QHXtl`,
	"cart-items-table__price-error": `CartItems_cart-items-table__price-error__hhkkn`,
	"cart-items-table__new-price-label": `CartItems_cart-items-table__new-price-label__ULBrj`,
	"cart-items-table__new-price-wrapper": `CartItems_cart-items-table__new-price-wrapper__2idN0`,
	"cart-items-table__new-price-currency": `CartItems_cart-items-table__new-price-currency__Du839`,
	"cart-items-table__new-price-actions": `CartItems_cart-items-table__new-price-actions__w59ku`,
	"cart-items-table__new-price-reject-btn": `CartItems_cart-items-table__new-price-reject-btn__Y81qw`,
	"cart-items-table__new-price-accept-btn": `CartItems_cart-items-table__new-price-accept-btn__ftMD2`,
	"cart-items-table__quantity-controls": `CartItems_cart-items-table__quantity-controls__5dclv`,
	"cart-items-table__quantity-error": `CartItems_cart-items-table__quantity-error__qzfkg`,
	"cart-items-table__delete-btn": `CartItems_cart-items-table__delete-btn__2XllU`
};
export default ___CSS_LOADER_EXPORT___;
